export default __webpack_public_path__ + "static/media/No contact covid.9c39add8.svg";